import {Route, Routes} from 'react-router-dom'
// import {PageLayout} from './components/PageLayout'
import {HomePage} from './pages/HomePage'

export const App = () => {
  return (
    // <PageLayout>
    <Routes>
      <Route path="/" element={<HomePage />} />
    </Routes>
    // </PageLayout>
  )
}
